export const array = {
  genRange(maxLength, orderBy = "asc") {
    return Array.from({ length: maxLength }, (_, i) => i + 1).sort((first, second) =>
      orderBy !== "desc" ? first - second : second - first
    );
  }
};
